import { render, staticRenderFns } from "./InviteCounselorModal.vue?vue&type=template&id=2b10cadd&scoped=true&"
import script from "./InviteCounselorModal.vue?vue&type=script&lang=js&"
export * from "./InviteCounselorModal.vue?vue&type=script&lang=js&"
import style0 from "./InviteCounselorModal.vue?vue&type=style&index=0&id=2b10cadd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b10cadd",
  null
  
)

export default component.exports